import { render, staticRenderFns } from "./TrainingProgramEventForm.vue?vue&type=template&id=1f7b2dc0"
import script from "./TrainingProgramEventForm.vue?vue&type=script&lang=js"
export * from "./TrainingProgramEventForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports